const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const ZIP_PATTERN = /^\d{3}-?\d{4}$/

const FIELD_LABELS = {
  company: "会社名／屋号",
  name: "氏名",
  zip: "郵便番号",
  prefecture: "都道府県",
  address: "以降の住所",
  tell: "電話番号",
  email: "メールアドレス",
  message: "内容",
}

const FORM_FIELDS = {
  inquiry: ["company", "name", "zip", "prefecture", "address", "tell", "email", "message"],
  trial: ["company", "name", "tell", "email"],
}

const REQUIRED_FIELDS = {
  inquiry: ["company", "name", "tell", "email", "message"],
  trial: ["company", "name", "tell", "email"],
}

function normalize(value) {
  return (value || "").trim()
}

function validateField(field, value, formType) {
  const normalized = normalize(value)

  if (REQUIRED_FIELDS[formType].includes(field) && normalized === "") {
    return "必須項目です"
  }

  if (normalized === "") {
    return null
  }

  if (field === "email" && !EMAIL_PATTERN.test(normalized)) {
    return "メールアドレスの形式が正しくありません"
  }

  if (field === "zip" && !ZIP_PATTERN.test(normalized)) {
    return "郵便番号の形式が正しくありません"
  }

  return null
}

function validateForm(form, formType) {
  const errors = {}

  FORM_FIELDS[formType].forEach((field) => {
    const input = form.querySelector(`[name="${field}"]`)
    if (!input) return

    const message = validateField(field, input.value, formType)
    if (message) {
      errors[field] = message
    }
  })

  return errors
}

function showFieldErrors(form, errors) {
  form.querySelectorAll("[data-error-for]").forEach((node) => {
    if (node.dataset.errorFor === "form") return

    const field = node.dataset.errorFor
    const message = errors[field]

    if (message) {
      node.textContent = message
      node.hidden = false
    } else {
      node.textContent = ""
      node.hidden = true
    }
  })
}

function clearErrors(form) {
  showFieldErrors(form, {})
  const globalError = form.querySelector('[data-error-for="form"]')
  if (globalError) {
    globalError.textContent = ""
    globalError.hidden = true
  }
}

function collectValues(form, formType) {
  const values = {}

  FORM_FIELDS[formType].forEach((field) => {
    const input = form.querySelector(`[name="${field}"]`)
    values[field] = input ? normalize(input.value) : ""
  })

  return values
}

function renderConfirmList(container, values, formType) {
  container.innerHTML = ""

  FORM_FIELDS[formType].forEach((field) => {
    const value = values[field]
    if (!value) return

    const dl = document.createElement("dl")
    const dt = document.createElement("dt")
    const dd = document.createElement("dd")

    dt.textContent = FIELD_LABELS[field]
    dd.textContent = value
    dl.appendChild(dt)
    dl.appendChild(dd)
    container.appendChild(dl)
  })
}

function showStep(root, stepName) {
  root.querySelectorAll("[data-step]").forEach((step) => {
    step.classList.toggle("is-hidden", step.dataset.step !== stepName)
  })

  if (stepName === "confirm") {
    ensureTurnstile(root)
  }
}

function ensureTurnstile(root) {
  const siteKey = root.dataset.turnstileSiteKey
  if (!siteKey) return

  const container = root.querySelector(".cf-turnstile")
  if (!container || container.dataset.rendered === "true") return

  const renderWidget = () => {
    if (!window.turnstile) return false

    const widgetId = window.turnstile.render(container, { sitekey: siteKey })
    container.dataset.rendered = "true"
    container.dataset.widgetId = widgetId
    return true
  }

  if (renderWidget()) return

  const timer = window.setInterval(() => {
    if (renderWidget()) {
      window.clearInterval(timer)
    }
  }, 100)

  window.setTimeout(() => window.clearInterval(timer), 10000)
}

function resetTurnstile(root) {
  const container = root.querySelector(".cf-turnstile")
  if (!container || !container.dataset.widgetId || !window.turnstile) return

  window.turnstile.reset(container.dataset.widgetId)
}

function initForm(root) {
  const formType = root.dataset.formType
  const form = root.querySelector("form")
  const confirmList = root.querySelector(".sr-office-form__confirm-list")
  const turnstileSiteKey = root.dataset.turnstileSiteKey

  if (!form || !FORM_FIELDS[formType]) return

  form.addEventListener("click", (event) => {
    const button = event.target.closest("[data-action]")
    if (!button) return

    const action = button.dataset.action

    if (action === "confirm") {
      event.preventDefault()
      clearErrors(form)

      const errors = validateForm(form, formType)
      if (Object.keys(errors).length > 0) {
        showFieldErrors(form, errors)
        const firstInvalid = form.querySelector(`[name="${Object.keys(errors)[0]}"]`)
        firstInvalid?.focus()
        return
      }

      renderConfirmList(confirmList, collectValues(form, formType), formType)
      showStep(root, "confirm")
      root.scrollIntoView({ behavior: "smooth", block: "start" })
    }

    if (action === "back") {
      event.preventDefault()
      clearErrors(form)
      resetTurnstile(root)
      showStep(root, "input")
    }
  })

  form.addEventListener("submit", (event) => {
    clearErrors(form)

    const errors = validateForm(form, formType)
    if (Object.keys(errors).length > 0) {
      event.preventDefault()
      showStep(root, "input")
      showFieldErrors(form, errors)
      return
    }

    if (turnstileSiteKey) {
      const token = form.querySelector('[name="cf-turnstile-response"]')
      if (!token || !token.value) {
        event.preventDefault()
        const globalError = form.querySelector('[data-error-for="form"]')
        if (globalError) {
          globalError.textContent = "認証を完了してください。"
          globalError.hidden = false
        }
      }
    }
  })
}

function initForms() {
  document.querySelectorAll(".sr-office-form").forEach(initForm)
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initForms)
} else {
  initForms()
}

export default initForms
